import { Injectable } from '@angular/core';

import { EConstantsGroups, Constant, HttpParameter } from '../datatypes/misc';
import { HttpClientHelper } from '../helpers/HttpClientHelper';
import { commonListItem1 } from '../models/common-list.model';
import { TenantConstant } from '../models/tenantconstant.model';
import { Observable } from 'rxjs';

@Injectable()
export class ConstantsService {

    constructor(private httpClientHelper: HttpClientHelper) {}

    getHours(): Observable<Constant[]> {
        const name = EConstantsGroups[EConstantsGroups.HOURS];
        return this.httpClientHelper.httpGet(new HttpParameter('Constants.ListByGroupName',
            [`?groupName=${name}`]));
    }

    getJobTypes(): Observable<Constant[]> {
        const name = EConstantsGroups[EConstantsGroups.JOB_TYPE];
        return this.httpClientHelper.httpGet(new HttpParameter('Constants.ListByGroupName',
            [`?groupName=${name}`]));
    }

    getApplicationTypes(): Observable<Constant[]> {
        const name = EConstantsGroups[EConstantsGroups.APPLICATION_TYPE];
        return this.httpClientHelper.httpGet(new HttpParameter('Constants.ListByGroupName',
            [`?groupName=${name}`]));
    }

    getSources(): Observable<Constant[]> {
        const name = EConstantsGroups[EConstantsGroups.SOURCE];
        return this.httpClientHelper.httpGet(new HttpParameter('Constants.ListByGroupName',
            [`?groupName=${name}`]));
    }

    getOpportunities(): Observable<Constant[]> {
        const name = EConstantsGroups[EConstantsGroups.OPPORTUNITIES];
        return this.httpClientHelper.httpGet(new HttpParameter('Constants.ListByGroupName',
            [`?groupName=${name}`]));
    }

    getAvailabilityToWork(): Observable<Constant[]> {
        const name = EConstantsGroups[EConstantsGroups.AVAILABILITY_TO_WORK];
        return this.httpClientHelper.httpGet(new HttpParameter('Constants.ListByGroupName',
            [`?groupName=${name}`]));
    }

    getDefaultCollege(): Observable<Constant[]> {
        const name = EConstantsGroups[EConstantsGroups.DEFAULT_COLLEGE];
        return this.httpClientHelper.httpGet(new HttpParameter('Constants.ListByGroupName',
            [`?groupName=${name}`]));
    }

    getAdvertStatuses(): Observable<Constant[]> {
        const name = EConstantsGroups[EConstantsGroups.ADVERT_STATUS];
        return this.httpClientHelper.httpGet(new HttpParameter('Constants.ListByGroupName',
            [`?groupName=${name}`]));
    }

    getIndustrySectors(): Observable<string[]> {
        return this.httpClientHelper.httpGet(new HttpParameter('Constants.GetIndustrySectors'));
    }


    getSkills(): Observable<commonListItem1[]> {
        return this.httpClientHelper.httpGet(new HttpParameter('Common.Skills.ListAll'));
    }

    getCurrentlyStudyingInstitutes(): Observable<commonListItem1[]> {
        return this.httpClientHelper.httpGet(new HttpParameter('Common.Skills.ListAll'));
    }

    getNationalities(): Observable<commonListItem1[]> {
        return this.httpClientHelper.httpGet(new HttpParameter('Common.Nationalities.ListAll'));
    }

    getQualifiacations(): Observable<commonListItem1[]> {
        return this.httpClientHelper.httpGet(new HttpParameter('Common.Qualifications.ListAll'));
    }

    getStudyingInstitutes(): Observable<commonListItem1[]> {
        return this.httpClientHelper.httpGet(new HttpParameter('Common.StudyingInstitutes.ListAll'));
    }

    getRefereeContactOption(): Observable<TenantConstant[]> {
        return this.httpClientHelper.httpGet(new HttpParameter('Constants.GetRefereeContactOption'));
    }
}
